import React, { memo, useRef, useEffect } from 'react';
import { default as ChartJS } from 'chart.js/auto';
import { createUseStyles, useTheme } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';
import { buildChartConfig } from '../../../utils/charts';

import styles from './styles';

const useStyles = createUseStyles(styles, 'Chart');

const Chart = memo(({ type, data, getImage }) => {
    const theme = useTheme();
    const { t, locale } = useWeb5Context();
    const classes = useStyles();
    const containerRef = useRef(null);
    const chartRef = useRef(null);

    useEffect(() => {
        const ctx = chartRef.current.getContext('2d');

        let newData = buildChartConfig({
            type,
            data,
            theme,
            t,
            locale,
            container: containerRef.current,
        });

        const myChart = new ChartJS(ctx, newData);

        if (getImage || newData.options) {
            myChart.options.animation = {
                ...(newData?.options?.animation || {}),
                onComplete: (props) => {
                    if (!getImage) return;
                    const imageBase64 = props?.chart?.toBase64Image?.();
                    if (!imageBase64) return;
                    getImage(imageBase64);
                },
            };

            myChart.update();
        }

        const resizeObserver = new ResizeObserver(() => {
            myChart.resize();
        });

        resizeObserver.observe(chartRef.current);

        return () => {
            myChart.destroy();
            resizeObserver.disconnect();
        };
    }, [type, data, getImage, t, theme, locale]);

    return (
        <div className={classes.root} ref={containerRef}>
            <canvas
                className={classes.chartCanvas}
                ref={chartRef}
                width="600"
                height="280"
                onMouseDown={(e) => e?.stopPropagation()}
            />
        </div>
    );
});

export default Chart;
